<template>
  <el-skeleton :loading="loading" :throttle="300">
    <template slot="template">
      <div :class="$style.product">
        <div :class="$style.product_cover" style="width: 240px; height: 180px">
          <el-skeleton-item :class="$style.product_img" variant="image" />
        </div>
        <div :class="$style.product_content">
          <div :class="$style.product_heading">
            <el-skeleton-item :class="$style.product_title" variant="h1" />
          </div>
          <el-skeleton-item
            :class="$style.product_info_item"
            class="w-2/3"
            variant="h3"
          />
          <el-skeleton-item
            :class="$style.product_info_item"
            class="w-1/2"
            variant="h3"
          />
          <el-skeleton-item
            :class="$style.product_info_item"
            class="w-1/2"
            variant="h3"
          />
        </div>
        <div :class="$style.product_right">
          <div :class="$style.product_company">
            <el-skeleton-item
              :class="$style.product_company_logo"
              class="ml-auto"
              variant="image"
            />
            <el-skeleton-item
              class="w-[100px]"
              :class="$style.product_company_title"
              variant="h3"
            />
          </div>
          <div class="absolute right-0 bottom-0">
            <el-skeleton-item
              :class="$style.product_price"
              class="mb-3 w-20 ml-auto"
              variant="text"
            />
            <el-skeleton-item
              :class="$style.product_price"
              class="mb-3 w-20 ml-auto"
              variant="text"
            />
            <div :class="$style.product_action_wrap">
              <el-skeleton-item
                v-for="i in 3"
                :key="i"
                :class="$style.product_action"
                class="min-w-[100px] ml-2"
                variant="button"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <div :class="$style.product">
      <div :class="$style.product_cover">
        <v-responsive :aspect-ratio="240 / 180">
          <a
            class="absolute inset-0"
            :href="productLink"
            target="_blank"
            :title="product.name"
          >
            <el-image
              :class="$style.product_img"
              fit="cover"
              :src="product.image"
              lazy
            />
          </a>

          <template v-if="loggedIn">
            <el-image
              v-if="isFavorite"
              :class="$style.product_collect"
              lazy
              @click="onToggleFavorite"
              fit="cover"
              src="~@/assets/img/resource/collected-icon.png"
            />
            <el-image
              v-else
              :class="$style.product_collect"
              lazy
              @click="onToggleFavorite"
              fit="cover"
              src="~@/assets/img/resource/collect-icon.png"
            />
          </template>
        </v-responsive>
      </div>
      <div :class="$style.product_content">
        <div class="flex">
          <div :class="$style.product_info" class="pr-[60px]">
            <h4 :class="$style.product_heading">
              <el-tooltip placement="bottom-start" :popper-class="$style.popper_class_tooltip" v-if="product.level_pic" :visible-arrow="false" effect="light">
                <div slot="content">
                  <div class="mb-1"><span :class="$style.title">黑标：</span>精选邮轮市场畅销产品，一手库存、价格，快速成交，提供有竞争力的佣金，获得更高的回报。</div>
                  <div class="mb-1"><span :class="$style.title">金标：</span>覆盖市场大部分需求，实时更新库存，让您时刻了解产品的可售性，保障业务稳定发展。</div>
                  <div class="mb-1"><span :class="$style.title">银标：</span>覆盖全球市场多个领域，确保满足不同客户的需求，推动您的业务多元化的发展。</div>
                </div>
                <div :class="$style.label_icon">
                  <el-image fit="cover" :class="$style.label_icon" :src="product.level_pic"></el-image>
                </div>
              </el-tooltip>
              <a
                :class="[$style.product_title, {[$style.info_name]: product.level_pic }]"
                :href="productLink"
                :title="product.name"
                target="_blank"
                class="title transition-colors hover:text-primary"
              >
                {{ product.name }}
              </a>
            </h4>
            <ul class="flex flex-wrap mt-2 h-6 overflow-hidden">
              <li
                class="inline-flex items-center px-1 rounded-sm text-xxs mr-2 mb-2 h-5"
                v-for="(item, index) in product.product_tags"
                :key="index"
                :class="[
                  index === 0
                    ? {
                        'bg-orange text-white':
                          Number(product.cruise_product_type) === 2,
                        'bg-purple text-white':
                          Number(product.cruise_product_type) === 1,
                      }
                    : 'border border-[#7378E6] text-[#7378E6]',
                ]"
              >
                {{ item }}
              </li>
            </ul>
            <div>
              <div :class="[$style.product_info_item, $style.product_dep]">
                <i
                  :class="$style.product_info_item_icon"
                  class="ficon ficon-ziyuancaigou_chufa mr-3"
                />出发：
                <div
                  :class="$style.product_info_item_content"
                  class="line-clamp-1"
                >
                  {{ product.departure }}
                </div>
              </div>
              <div
                v-if="product.ports && product.ports.length"
                :class="[$style.product_info_item, $style.product_port]"
              >
                <i
                  :class="$style.product_info_item_icon"
                  class="ficon ficon-ziyuancaigou_gangkou mr-3"
                />
                <VEllipsis
                  :class="$style.product_info_item_content"
                  :rows="1"
                  symbol="查看行程"
                  :expandable="false"
                  suffix=""
                  >途经：{{ product.ports.join(",")
                  }}<template #suffix
                    ><button
                      class="text-highlight ml-1"
                      type="button"
                      @click="handleViewTrip"
                    >
                      查看行程
                    </button></template
                  ></VEllipsis
                >
              </div>
              <div :class="[$style.product_info_item, $style.product_dates]">
                <i
                  :class="$style.product_info_item_icon"
                  class="ficon ficon-ziyuancaigou_chufariqi mr-3"
                />
                <VEllipsis
                  :class="$style.product_info_item_content"
                  :rows="2"
                  symbol="查看更多"
                  :expandable="false"
                  suffix=""
                  >出游日期：{{ product.product_date }}
                  <template #suffix>
                    <button
                      v-show="product.product_date.split('、').length >= 4"
                      class="text-highlight ml-1"
                      type="button"
                      @click="handleViewTravelDate"
                    >
                      查看更多
                    </button>
                  </template>
                </VEllipsis>
              </div>
            </div>
          </div>
          <div :class="$style.product_right">
            <div :class="$style.product_company">
              <el-image
                :class="$style.product_company_logo"
                :fit="fit"
                :style="{
                  padding:
                    searchBand == 7 ? '1px' : searchBand == 9 ? '3px' : '',
                }"
                :src="product.company_logo_url"
              />
              <div :class="$style.product_company_title">
                {{ product.company }}
              </div>
            </div>
          </div>
        </div>
        <div class="absolute right-0 bottom-0">
          <div :class="$style.product_price_container" class="">
            <div
              :class="[$style.product_price, isDistributor ? $style.sale : '']"
            >
              <span v-if="isDistributor" :class="$style.product_price_label"
                >零售价：</span
              >
              <span :class="$style.product_price_curr">{{
                product.currency_label
              }}</span>
              <span :class="$style.product_price_num">{{
                product.min_sale_price
              }}</span>
              <span :class="$style.product_price_unit">起/人</span>
            </div>
            <div v-if="isDistributor" :class="$style.product_price">
              <span :class="$style.product_price_label">同行价：</span>
              <span :class="$style.product_price_curr">{{
                product.currency_label
              }}</span>
              <span :class="$style.product_price_num">{{
                product.min_th_price
              }}</span>
              <span :class="$style.product_price_unit">起/人</span>
            </div>
          </div>
          <div :class="$style.product_action_wrap">
            <el-button
              :class="[$style.product_action, $style.product_action_hover]"
              v-if="!isInShop && isDistributor && isOpenShop"
              class="min-w-[100px] rounded border-darker text-dark"
              icon="ficon ficon-dianpuguanlishuju mr-1"
              @click="onJoinShop"
            >
              加入店铺</el-button
            >
            <el-button
              :class="[$style.product_action, $style.product_action_hover]"
              v-if="isDistributor"
              class="min-w-[100px] rounded border-darker text-dark"
              icon="ficon ficon-xingzhuangjiehe2 mr-1"
              @click="handleShareShopPrdouct"
            >
              分享产品</el-button
            >
            <el-button
              :class="$style.product_action"
              class="w-35"
              type="primary"
              @click="onViewDetail"
              >查看详情</el-button
            >
          </div>
        </div>

        <share-shop-product ref="shareShopProduct"></share-shop-product>

        <!-- 行程 -->
        <CruiseTripDialog
          :visible.sync="isOpenViewTrip"
          :title="viewTripState.title"
          :product_no="viewTripState.product_no"
        />

        <!--查看产品出发日期--->
        <ProductDatesDialog
          v-if="isOpenViewTravelDate"
          :visible.sync="isOpenViewTravelDate"
          :product_no="viewTravelDateState.product_no"
        ></ProductDatesDialog>
      </div>
    </div>
  </el-skeleton>
</template>

<script>
import {
  defineComponent,
  ref,
  useStore,
  computed,
  useRoute,
  reactive,
} from "@nuxtjs/composition-api";
import VResponsive from "~/components/VResponsive/VResponsive.vue";
import useProductFavorite from "~/views/product/composables/useProductFavorite";
import useProductJoinShop from "~/views/product/composables/useProductJoinShop";

import ShareShopProduct from "@/views/product/components/ShareShopProduct/index.vue";

import { buildProductDetailLink } from "@/utils/product";
import { ProductTypes } from "@/constants/productType";

import VEllipsis from "~/components/VEllipsis/index.vue";
import CruiseTripDialog from "@/components/product/cruise-trip-dialog.vue";
import ProductDatesDialog from "@/components/product/product-dates-dialog.vue";
export default defineComponent({
  name: "ProductListItem",
  components: {
    VResponsive,
    ShareShopProduct,
    VEllipsis,
    CruiseTripDialog,
    ProductDatesDialog
  },
  props: {
    loading: Boolean,
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["refresh", "view-trip"],
  setup(props) {
    const route = useRoute();
    const searchBand = computed(() => route.value.query.brand);
    const fit = computed(() => (route.value.query.brand == 7 ? "contain" : ""));
    // ======================= 产品详情 =======================

    const productLink = computed(() =>
      buildProductDetailLink({
        product_no: props.product.product_no,
        product_type: ProductTypes.CRUISE,
        is_tripartite_product: props.product.is_tripartite_product,
      })
    );

    const onViewDetail = () => {
      window.open(productLink.value, "_blank");
    };

    // ======================= 收藏 =======================
    const { isFavorite, onToggleFavorite } = useProductFavorite(
      props.product.product_no,
      !!props.product.is_favorite
    );

    // ======================= 分享 =======================
    const shareShopProduct = ref();
    const handleShareShopPrdouct = () => {
      shareShopProduct.value.handleShareShopPrdouct(props.product);
    };

    // ======================= 加入店铺 =======================
    const store = useStore();
    const isDistributor = computed(() => store.getters.isDistributor);
    const isAdmin = computed(() => store.getters.isAdmin);
    const isOpenShop = computed(() => store.getters.isOpenShop);
    const loggedIn = computed(() => store.getters.loggedIn);

    const { isInShop, onJoinShop, updateJoinShopStatus } = useProductJoinShop(
      computed(() => props.product.product_no)
    );
    updateJoinShopStatus(props.product.in_shop);

    isInShop.value = props.product.in_shop;

    // ======================= 查看出游日期 =======================
    const isExpandDate = ref(false);

    // ======================= 查看行程 =======================
    const isOpenViewTrip = ref(false);
    const viewTripState = reactive({
      title: "",
      product_no: "",
      // tours: []
    });
    const handleViewTrip = async () => {
      const { product } = props;
      isOpenViewTrip.value = true;
      viewTripState.title = product.name;
      viewTripState.product_no = product.product_no;
    };

    // ======================= 查看出游日期 =======================
    const isOpenViewTravelDate = ref(false);
    const viewTravelDateState = reactive({
      product_no: "",
    });
    const handleViewTravelDate = async () => {
      const { product } = props;
      isOpenViewTravelDate.value = true;
      console.log(product);
      viewTravelDateState.product_no = product.product_no;
    };
    return {
      productLink,

      isDistributor,

      isFavorite,
      onToggleFavorite,

      onViewDetail,

      shareShopProduct,
      handleShareShopPrdouct,

      isAdmin,
      isOpenShop,
      loggedIn,
      isInShop,
      onJoinShop,

      searchBand,
      fit,
      isExpandDate,

      isOpenViewTrip,
      viewTripState,
      handleViewTrip,

      isOpenViewTravelDate,
      viewTravelDateState,
      handleViewTravelDate,
    };
  },
});
</script>

<style lang="scss" module>
.product {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.product_cover {
  margin-right: 1.75rem;
  width: 17.5rem;
}
.product_img {
  border-radius: 0.5rem;
  height: 100%;
  overflow: hidden;
  width: 100%;
}
.product_collect {
  cursor: pointer;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 2.5rem;
}
.product_content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: hidden;
  padding-bottom: 3.25rem;
  position: relative;
}
.product_info {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: hidden;
}
.product_info_wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.product_info_right {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin-left: 4.5rem;
}
.product_info_item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_info_item_icon {
  font-size: 1.25rem;
  line-height: 1.75rem;
  line-height: 1.5rem;
}
.product_info_item_content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: hidden;
}
.product_company {
  text-align: right;
}
.product_company_logo {
  border-radius: 0.25rem;
  border-width: 1px;
  height: 2.25rem;
  width: 6.5rem;
  border-color: #979aa8;
}
.product_company_title {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0.25rem;
  text-align: right;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_price {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  -webkit-align-items: baseline;
  align-items: baseline;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  font-size: 1.875rem;
  line-height: 2.25rem;
  white-space: nowrap;
}
.product_price_container {
  margin-bottom: 0.75rem;
  position: absolute;
  right: 0px;
  bottom: 100%;
}
.product_price.sale .product_price_label {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.product_price.sale .product_price_curr {
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_price.sale .product_price_num {
  font-size: 1.25rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_price_label {
  font-size: 1rem;
  line-height: 1.5rem;
}
.product_price_curr {
  font-size: 1rem;
  line-height: 1.5rem;
}
.product_price_num, .product_price_curr {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(204, 75, 12, var(--tw-text-opacity));
}
.product_price_unit {
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-left: 0.25rem;
}
.product_heading {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-bottom: 0.625rem;
}
.product_title {
  display: block;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.product_right {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -ms-flex-negative: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  position: relative;
  width: 9rem;
}
.product_action_hover:hover {
  border-color: #005edc;
}
.info_name {
  text-indent: 28px;
  margin-left: -26px;
}
.label_icon {
  height: 28px;
  width: 28px;
  margin-left: -1px;
}
.popper_class_tooltip {
  border: 1px solid #D4D7DE !important;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1) !important;
  width: 248px !important;
  color: #1F2129;
  padding: 8px 10px 6px;
  margin-top: 2px !important;
  text-align: justify;
}
.title {
  font-weight: 500;
}
</style>
